import { type DateTime } from "luxon";
import IdentityObject from "@/src/domain/common/identity-object";
import type Alarm from "@/src/domain/models/alarm";
import type PageLike from "@/src/domain/models/page-like";

export default abstract class AlarmService extends IdentityObject {
  abstract fetchAlarmDataByDevice(
    deviceId: number,
    startDate: DateTime | null,
    endDate: DateTime,
    currentPage: number
  ): Promise<PageLike<Alarm>>;

  abstract fetchAllPaginatedAlarms(
    deviceId: number,
    startDate: DateTime,
    endDate: DateTime
  ): Promise<Alarm[]>;

  abstract fetchActiveAlarmSummary(): Promise<Alarm[]>;

  abstract fetchActiveAlarmCount(): Promise<number>;

  abstract markAlarmAsRead(id: string): Promise<void>;
  abstract markAllAsRead(): Promise<void>;
}
